import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./assets/css/app.css";
import setupTokenRefresh from "./plugins/tokenRefresh";
import { useGuideStore } from "./stores/guides";
import { loadApiExtensions } from "./services/api";
import BreadcrumbNav from '@/components/BreadcrumbNav.vue';

async function bootstrap() {
  await loadApiExtensions();

  const app = createApp(App);

  app.use(createPinia());
  app.use(router);
  setupTokenRefresh();
  const guides = useGuideStore();
  // guides.loadFromApi();
  app.component('BreadcrumbNav', BreadcrumbNav)

  app.mount("#app");
}

bootstrap();
